module.exports = __webpack_public_path__ + "img/ios-download-black.09c355a1.png";